import { isHotelPriceFreezeVoucher } from "@b2bportal/core-types";
import { isPriceFreezeVoucherActive } from "@b2bportal/core-utilities";
import { priceFreezeApi } from "@b2bportal/price-freeze-api";
import axios from "axios";

import type { HotelsPriceFreezeExercisePartialMachineContext } from "../types";

export const fetchPriceFreezeVoucher = async (
  context: HotelsPriceFreezeExercisePartialMachineContext
) => {
  const priceFreezeId = context.priceFreeze.priceFreezeId;
  const res = await priceFreezeApi(axios).apiV3PricefreezeVoucherListPost();

  return res.data.vouchers
    .filter(isHotelPriceFreezeVoucher)
    .filter(isPriceFreezeVoucherActive)
    .find((voucher) => voucher.priceFreezeId === priceFreezeId);
};
